import { PetContextValues } from 'contexts/pet';
import { isFoodType } from 'interfaces/api-input/input-product-type';
import getPetProfileArray from 'modules/pet-profile/personalized-cdp/utils/get-pet-profile-array';
import { PetProfile } from 'types/pet-profile';

interface GetPetProfileUrlOptions {
  petProfile: PetProfile;
  current: PetContextValues;
  petId?: string;
}

/**
 * Determines the URL pet type from context or profile
 */
const getPetTypeForUrl = (
  current: PetContextValues,
  petProfile: PetProfile
): 'cat' | 'dog' => {
  if (current) return current === 'cats' ? 'cat' : 'dog';

  return petProfile.petType === 'cat' ? 'cat' : 'dog';
};

/**
 * Generates a pet profile URL with the new dynamic routing structure
 */
export const getPetProfileUrl = ({
  petProfile,
  current,
  petId,
}: GetPetProfileUrlOptions): string => {
  // Determine the pet type from context or profile
  const petType = getPetTypeForUrl(current, petProfile);

  const params = new URLSearchParams();

  // Add pet ID if provided (for switching to specific pet)
  if (petId) {
    params.append('id', petId);
  }

  // Add edit parameter only for completely empty profiles (0 non-food-type attributes)
  // This ensures users exit edit mode immediately after making any selection
  const array = getPetProfileArray({ petProfile }).filter(
    (v) => !isFoodType(v)
  );
  if (array.length === 0) {
    params.append('edit', '1');
  }

  const queryString = params.toString();
  return `/pet-profile/${petType}${queryString ? `?${queryString}` : ''}`;
};

/**
 * Simple helper to generate pet profile URL with just pet type
 */
export const getPetProfileUrlWithType = (petType: 'cat' | 'dog'): string => {
  return `/pet-profile/${petType}`;
};
